<template>
  <div class="cascaderSelectPop" :style="{ paddingTop: `${searchHeightVw}vw` }">
    <div
      class="cascaderSelectPop_fixed"
      :class="isShowSearch ? 'openSearch' : ''"
    >
      <span
        class="searchArea"
        :style="{ height: `${searchHeightVw - 1.388}vw` }"
      >
        <template
          v-if="isShowSearch && searchWidthPxArr && searchWidthPxArr.length > 0"
        >
          <span
            class="searchList"
            v-for="(searchItem, searchIndex) in searchWidthPxArr"
            :key="searchIndex"
            :style="{ width: `${searchItem}px` }"
          >
            <searchBox
              v-show="searchItem > 0"
              :placeholderText="searchPlaceholderArr[searchIndex]"
              @filterInputVal="filterInputValHandler"
            ></searchBox>
          </span>
        </template>
      </span>
      <span class="searchArea_btnArea" @click="clickSearchBtn(isShowSearch)">
        <span class="btnArea_centerWihte"></span>
      </span>
    </div>
    <div
      class="cascaderSelectPop_main"
      v-if="meunArrWeb && meunArrWeb.length > 0"
    >
      <span
        class="selectItem"
        v-for="(meunItem, meunIndex) in meunArrWeb"
        :key="meunIndex"
        :class="meunItem ? '' : 'isHide'"
        :ref="`selectItem_${meunIndex}`"
      >
        <span class="selectItem_status" v-if="meunItem && meunItem.length == 0">
          <span class="loaderArea" v-show="loading">
            <span class="loader-67"></span>
            <span class="loadText" v-text="loadText"></span>
          </span>
          <span class="notData" v-show="!loading" v-text="notDataText"></span>
        </span>
        <span class="selectItem_list" v-if="meunItem && meunItem.length > 0">
          <span
            class="selectItemList_row"
            v-for="item in meunItem"
            :key="item.value"
            @click="clickItem(meunIndex, item)"
            :class="meunRowHighlight(meunIndex, item) ? 'act' : ''"
          >
            <span class="selectRow_name" v-text="item.label"></span>
            <span
              class="selectRow_icon el-icon el-icon-arrow-right"
              v-if="
                item[options.children] && item[options.children].length >= 0
              "
            ></span>
            <span
              class="el-icon-check el-icon selectAct_icon"
              v-show="
                meunIndex === meunArrWeb.length - 1 &&
                meunRowHighlight(meunIndex, item)
                  ? 'act'
                  : ''
              "
            ></span>
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import searchBox from './custom_searchBox.vue'
export default {
  name: 'cascaderSelectPop',
  components: { searchBox },
  props: {
    meunList: {
      type: Array,
      default: () => {
        return []
      },
    },
    valueArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    options: {
      type: Object,
      default: () => ({
        value: 'value',
        label: 'label',
        children: 'children',
      }),
    },
    loadChildCallback: {
      type: Function,
      default: () => {},
    },
    isShowSearch: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShowSearch(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.changeSearchDom(newVal)
      }
    },
    valueArr(newVal, oldVal) {
      console.debug(
        'change valueArr:',
        JSON.stringify(newVal),
        JSON.stringify(oldVal),
        this.selectLastValFlag,
        this.actValueArr
      )
      if (this.meunList.length > 0 && !this.selectLastValFlag) {
        this.meunArrWeb = this.computedMeunArr()
      } else {
        this.selectLastValFlag = false
      }
    },
    meunList(newVal, oldVal) {
      console.debug('change meunList:', this.valueArr, this.actValueArr)
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.meunArrWeb = this.computedMeunArr()
      }
    },
    immediate: false,
    deep: true,
  },
  data() {
    return {
      selectLastValFlag: false, //如果选中最后一个， valueArr 变化，但不需要执行 this.computedMeunArr()
      notDataText: '暂无数据',
      loadText: '加载中...',
      loading: false,
      actValueArr: [],
      meunArrWeb: [],
      searchPlaceholderArr: [
        '大项',
        '小项',
        '日期',
        '时间 | 对阵信息 | 比赛名称',
      ],
      searchWidthPxArr: [],
      defaultSelectItemWidth: 11.25,
      searchHeightVw: 2.4,
      searchValArr: [], //没有选中值是为null
    }
  },
  methods: {
    _valFormatHandler(val) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        data = val
      }
      // console.debug(val, data)
      return data
    },
    filterInputValHandler(item) {
      // 将搜索框里面的新值插入searchValArr，然后开始过滤
      const { val, placeholder } = item
      let index = this.searchPlaceholderArr.indexOf(placeholder)
      if (index > -1) {
        let searchValArr = []
        this.searchValArr.forEach((searchVal, searchIndex) => {
          if (searchIndex === index) {
            searchValArr.push(val)
          } else {
            searchValArr.push(searchVal)
          }
        })
        this.searchValArr = searchValArr
        this.filterSearchItemHandler(index, val, 'single')
      }
      console.debug(this.searchValArr, index, val)
    },
    filterSearchItemHandler(changeInputIndex, newVal, state) {
      // 根据changeInputIndex搜索框的索引 和 newVal新值 来过滤数据
      let meunArrWeb = JSON.parse(JSON.stringify(this.meunArrWeb))
      console.debug(
        this.save_filterPreData,
        changeInputIndex,
        this.actValueArr,
        this.meunArrWeb,
        state
      )

      let type = 'filter'
      if (!newVal) {
        type = 'clear'
      }
      if (!this.save_filterPreData) {
        this.resetFilterPreData()
      }

      if (state === 'allReset') {
        console.debug(
          changeInputIndex,
          this.save_filterPreData.save_actValueArr[changeInputIndex - 1],
          this.actValueArr[changeInputIndex - 1],
          this.save_filterPreData.save_actValueArr[changeInputIndex],
          this.actValueArr[changeInputIndex]
        )
        if (changeInputIndex > 0) {
          // 第一列大项，无论什么情况他的save_meunArrWeb都是不变的；只有后面的才会因为点击切换，是不是上一列变化导致2个值不一样，如果上一列变化了，新值为null,则需要改变save_meunArrWeb，如果只是自身点击变化则不需要改变save_meunArrWeb
          console.debug(changeInputIndex)
          if (
            this.save_filterPreData.save_actValueArr[changeInputIndex - 1] ===
              this.actValueArr[changeInputIndex - 1] &&
            this.save_filterPreData.save_actValueArr[changeInputIndex] !==
              this.actValueArr[changeInputIndex] &&
            this.actValueArr[changeInputIndex]
          ) {
          } else {
            this.save_filterPreData.save_meunArrWeb[changeInputIndex] =
              meunArrWeb[changeInputIndex]
          }
        }

        this.save_filterPreData.save_actValueArr[changeInputIndex] =
          this.actValueArr[changeInputIndex]
      }

      let { save_actValueArr, save_meunArrWeb } = this.save_filterPreData
      if (type === 'filter') {
        if (state === 'single') {
          if (
            save_actValueArr[changeInputIndex] ===
            this.actValueArr[changeInputIndex]
          ) {
            // 小项id相等时，只比较meunArrWeb里面的元素个数，保留最大的一组，存起来
            if (
              save_meunArrWeb[changeInputIndex].length <
              meunArrWeb[changeInputIndex].length
            ) {
              save_meunArrWeb[changeInputIndex] = meunArrWeb[changeInputIndex]
            }
          } else {
            // 大项|小项|日期|比赛id不相等时，重新遍历this.actValueArr数组，比较最新的actValueArr与save_actValueArr里面是否相等
            // 当大项不一样，则大项之后要重新保存
            // 当小项不一样，则小项之后要重新保存
            let isResaveFlag = false
            this.actValueArr.forEach((item, itemIndex) => {
              if (item !== save_actValueArr[itemIndex]) {
                // 第一次不的不保存
                if (isResaveFlag) {
                  // 最新值不与原来保存的相等，则进行覆盖
                  save_meunArrWeb[itemIndex] = this.meunArrWeb[itemIndex]
                }
                isResaveFlag = true
              } else if (
                item === null &&
                save_actValueArr[itemIndex] === null
              ) {
                // 2个都是null,直接替换
                save_meunArrWeb[itemIndex] = this.meunArrWeb[itemIndex]
              } else {
                // 如果相等，发现个数大的进行替换保存
                if (
                  save_meunArrWeb[itemIndex].length <
                  this.meunArrWeb[itemIndex].length
                ) {
                  save_meunArrWeb[itemIndex] = this.meunArrWeb[itemIndex]
                }
              }
            })
          }
          let filterMeunArr = []
          save_meunArrWeb[changeInputIndex].forEach((originItem) => {
            // if (originItem.value === this.actValueArr[changeInputIndex]) {
            //   // filterMeunArr.unshift(originItem)
            //   filterMeunArr.push(originItem)
            // } else if (originItem.label.indexOf(newVal) > -1) {
            //   filterMeunArr.push(originItem)
            // }
            if (originItem.label.indexOf(newVal) > -1) {
              filterMeunArr.push(originItem)
            }
          })

          this.meunArrWeb = meunArrWeb.map((meunItem, meunIndex) => {
            if (meunIndex === changeInputIndex) {
              return filterMeunArr
            } else {
              return meunItem
            }
          })
        } else if (state === 'allReset') {
          // if (
          //   save_actValueArr[changeInputIndex] !==
          //     this.actValueArr[changeInputIndex] ||
          //   (save_actValueArr[changeInputIndex] === null &&
          //     this.actValueArr[changeInputIndex] === null)
          // ) {
          //   save_meunArrWeb[changeInputIndex] = meunArrWeb[changeInputIndex]

          //   let filterMeunArr = []
          //   save_meunArrWeb[changeInputIndex].forEach((originItem) => {
          //     if (originItem.value === this.actValueArr[changeInputIndex]) {
          //       // filterMeunArr.unshift(originItem)
          //       filterMeunArr.push(originItem)
          //     } else if (originItem.label.indexOf(newVal) > -1) {
          //       filterMeunArr.push(originItem)
          //     }
          //   })

          //   this.meunArrWeb = meunArrWeb.map((meunItem, meunIndex) => {
          //     if (meunIndex === changeInputIndex) {
          //       return filterMeunArr
          //     } else {
          //       return meunItem
          //     }
          //   })
          // }

          // 上面已经重置过数据了，这里直接过滤
          let filterMeunArr = []
          save_meunArrWeb[changeInputIndex].forEach((originItem) => {
            // if (originItem.value === this.actValueArr[changeInputIndex]) {
            //   // filterMeunArr.unshift(originItem)
            //   filterMeunArr.push(originItem)
            // } else if (originItem.label.indexOf(newVal) > -1) {
            //   filterMeunArr.push(originItem)
            // }
            if (originItem.label.indexOf(newVal) > -1) {
              filterMeunArr.push(originItem)
            }
          })

          this.meunArrWeb = meunArrWeb.map((meunItem, meunIndex) => {
            if (meunIndex === changeInputIndex) {
              return filterMeunArr
            } else {
              return meunItem
            }
          })
        }
      } else if (type === 'clear') {
        // let meunArrWeb = JSON.parse(JSON.stringify(this.meunArrWeb))
        if (state === 'single') {
          this.meunArrWeb = meunArrWeb.map((meunItem, meunIndex) => {
            if (meunIndex === changeInputIndex) {
              return save_meunArrWeb[changeInputIndex]
            } else {
              return meunItem
            }
          })
        } else if (state === 'allReset') {
          // if (
          //   this.actValueArr[changeInputIndex] !==
          //   save_actValueArr[changeInputIndex]
          // ) {
          //   // meunArrWeb[changeInputIndex] = save_meunArrWeb[changeInputIndex]
          //   this.save_filterPreData.save_meunArrWeb[changeInputIndex] =
          //     meunArrWeb[changeInputIndex]
          // } else if (
          //   this.actValueArr[changeInputIndex] === null &&
          //   save_actValueArr[changeInputIndex] === null
          // ) {
          //   // 由于点击菜单切换引起的，这个时候搜索框是空，所以这个时候重置就是保留this.meunArrWeb新出的数据
          //   this.save_filterPreData.save_meunArrWeb[changeInputIndex] =
          //     meunArrWeb[changeInputIndex]
          // } else {
          //   // 只有当2个id相等时，将保存的替换回去，这个时候属于之前过滤过，现在清除过滤
          //   console.debug(this.actValueArr[changeInputIndex], save_actValueArr[changeInputIndex])
          //   meunArrWeb[changeInputIndex] = save_meunArrWeb[changeInputIndex]
          // }
          // this.save_filterPreData.save_actValueArr[changeInputIndex] =
          //   this.actValueArr[changeInputIndex]
          // this.save_filterPreData.save_meunArrWeb[changeInputIndex] =
          //   meunArrWeb[changeInputIndex]
          this.meunArrWeb = meunArrWeb
        }
      }

      // 出现暂无数据后宽度可能跟之前不一样，要重新计算
      this.computedSearchWidthPxArr()
    },
    clickSearchBtn(flag) {
      this.$emit('isShowSearchEvent', !flag)
      this.changeSearchDom(!flag)
    },
    changeSearchDom(flag) {
      if (flag) {
        // 打开搜索框
        this.computedSearchWidthPxArr()
        this.searchHeightVw = 5
      } else {
        // 关闭搜索框
        this.searchHeightVw = 2.43
        this.searchWidthPxArr = []
        this.searchValArr = []
        if (
          this.save_filterPreData &&
          this.save_filterPreData.save_meunArrWeb
        ) {
          this.meunArrWeb = JSON.parse(
            JSON.stringify(this.save_filterPreData.save_meunArrWeb)
          )
        }
      }
    },
    computedSearchWidthPxArr(state, level) {
      let searchWidthPxArr = []
      this.$nextTick(() => {
        this.meunArrWeb.forEach((item, itemIndex) => {
          console.debug(this.$refs[`selectItem_${itemIndex}`][0].clientWidth)
          searchWidthPxArr.push(
            this.$refs[`selectItem_${itemIndex}`][0].clientWidth
          )
        })
        this.searchWidthPxArr = searchWidthPxArr
        console.debug('searchWidthPxArr:', searchWidthPxArr, this.meunArrWeb)
        if (this.searchValArr.length === 0) {
          let searchValArr = []
          this.searchWidthPxArr.forEach((searchWidth, searchWidthIndex) => {
            if (searchWidth > 0) {
              searchValArr[searchWidthIndex] = ''
            } else {
              searchValArr[searchWidthIndex] = null
            }
          })
          this.searchValArr = searchValArr
        }
        if (state && state === 'reset') {
          // 只有每次点击为菜单时才需要重置
          this.searchValArr.forEach((searchItem, searchIndex) => {
            if (searchIndex >= level) {
              this.filterSearchItemHandler(searchIndex, searchItem, 'allReset')
            }
          })
        }
      })
    },
    resetFilterPreData() {
      this.save_filterPreData = {
        save_actValueArr: JSON.parse(JSON.stringify(this.actValueArr)),
        save_meunArrWeb: JSON.parse(JSON.stringify(this.meunArrWeb)),
      }
    },
    renderMeunArrWeb(actValueArr, newChildren) {
      let meunArrWeb = this.meunArrWeb
      meunArrWeb.forEach((meun, meunIndex) => {
        console.debug(meun)
        if (meunIndex === 1) {
          meun.forEach((eventItem) => {
            if (actValueArr[1] === eventItem[this.options.value]) {
              eventItem[this.options.children] = newChildren
            }
          })
        }
      })
      this.meunArrWeb = meunArrWeb
    },
    computedMeunArr() {
      console.debug('actValueArr meunList:', this.meunList, this.valueArr)
      let meunArr = []
      let firstArr = []
      let childArr = []
      let actValueArr =
        this.valueArr && this.valueArr.length > 0 ? this.valueArr : []
      if (this.meunList && this.meunList.length > 0) {
        if (actValueArr.length === 0) {
          // 默认第一个
          let actIndex = 0
          this.meunList.forEach((meun, meunIndex) => {
            if (meunIndex == actIndex) {
              actValueArr.push(meun[this.options.value])
              actValueArr.push(this.fromIndex2Val(meun, actIndex))
              // childArr.push(this.getMeunItem(meun, actIndex))
              childArr = [this.getMeunItem(meun, actIndex)]
            }
            firstArr.push({
              [this.options.value]: meun[this.options.value],
              [this.options.label]: meun[this.options.label],
              [this.options.children]: meun[this.options.children],
            })
          })
        } else {
          this.meunList.forEach((meun) => {
            firstArr.push({
              [this.options.value]: meun[this.options.value],
              [this.options.label]: meun[this.options.label],
              [this.options.children]: meun[this.options.children],
            })
            if (actValueArr[0] === meun[this.options.value]) {
              this.needLoadValueArr = []
              actValueArr.forEach((actVal, index) => {
                if (index > 0) {
                  this.needLoadValueArr.push(actVal)
                }
              })
              childArr = this.getLoadMeunItem(meun)
            }
          })
        }
        this.setActValueArr(actValueArr)
        if (childArr && childArr.length > 0) {
          meunArr = [].concat([firstArr], childArr)
        } else {
          meunArr = [firstArr]
        }
        console.debug(
          'actValueArr:',
          this.valueArr,
          actValueArr,
          firstArr,
          childArr,
          meunArr
        )
      }
      return meunArr
    },
    async clickItem(level, item, flag) {
      console.debug('clickItem', item, this.actValueArr[level])
      if (item[this.options.value] !== this.actValueArr[level] || flag) {
        this.actValueArr = this.actValueArr.map((val, valIndex) => {
          let newVal = val
          if (valIndex === level) {
            newVal = item[this.options.value]
          } else if (valIndex > level) {
            newVal = null
          }
          return newVal
        })
        if (level === this.actValueArr.length - 1) {
          this.selectLastValFlag = true
          this.$emit('change', this.actValueArr)
        } else {
          let meunArrWeb = []
          let isRefresh = false
          await this.meunArrWeb.forEach(async (meun, meunIndex) => {
            if (meunIndex === level + 1) {
              if (
                item[this.options.children] &&
                item[this.options.children].length === 0 &&
                !flag
              ) {
                // 子数组为空，需要动态加载获取
                isRefresh = true
                this.loading = true
                meunArrWeb.push([])
                await this.loadChildCallback([
                  this.actValueArr[0],
                  this.actValueArr[1],
                ])
                console.debug(
                  'loadChildCallback:',
                  item,
                  isRefresh,
                  this.meunList
                )

                this.meunList.forEach((soprtsItem) => {
                  if (soprtsItem.value === this.actValueArr[0]) {
                    soprtsItem.children.forEach((eventItem) => {
                      if (eventItem.value === item.value) {
                        this.renderMeunArrWeb(
                          [this.actValueArr[0], this.actValueArr[1]],
                          eventItem.children
                        )
                        this.clickItem(
                          level,
                          {
                            value: item.value,
                            label: item.label,
                            children: eventItem.children,
                          },
                          true
                        )
                      }
                    })
                  }
                })

                this.loading = false
              } else {
                meunArrWeb.push(item[this.options.children])
              }
            } else {
              if (meunIndex <= level) {
                meunArrWeb.push(meun)
              } else {
                meunArrWeb.push(null)
              }
            }
          })

          // if (!isRefresh) {
          //   this.meunArrWeb = meunArrWeb
          // }
          this.meunArrWeb = meunArrWeb
          this.computedSearchWidthPxArr('reset', level)
          console.debug('isRefresh:', meunArrWeb, this.searchValArr, level)
        }
      }
      console.debug(level, item, this.actValueArr, this.meunArrWeb)
    },
    fromIndex2Val(item, index) {
      if (
        item[this.options.children] &&
        item[this.options.children].length > 0
      ) {
        return item[this.options.children][index][this.options.value]
      } else {
        return ''
      }
    },
    getMeunItem(item, index) {
      if (
        item[this.options.children] &&
        item[this.options.children].length > 0
      ) {
        let childMeunItemArr = []
        let curMeunItemArr = item[this.options.children].map(
          (child, childIndex) => {
            if (index >= 0 && index == childIndex) {
              childMeunItemArr = this.getMeunItem(child)
            }
            return {
              [this.options.value]: child[this.options.value],
              [this.options.label]: child[this.options.label],
              [this.options.children]: child[this.options.children]
                ? child[this.options.children]
                : null,
            }
          }
        )
        return [].concat(curMeunItemArr, childMeunItemArr)
      } else {
        return []
      }
    },
    getLoadMeunItem(item) {
      let meunItemArr = []
      console.debug(
        'getLoadMeunItem:',
        this.needLoadValueArr,
        item[this.options.children]
      )
      if (
        item[this.options.children] &&
        item[this.options.children].length > 0
      ) {
        console.debug(
          'getLoadMeunItem length:',
          this.needLoadValueArr,
          item[this.options.children]
        )
        let childMeunItemArr = []
        let actVal = this.needLoadValueArr.shift()
        let curMeunItemArr = item[this.options.children].map((child) => {
          if (
            this.needLoadValueArr.length > 0 &&
            child[this.options.value] === actVal
          ) {
            childMeunItemArr = this.getLoadMeunItem(child)
            meunItemArr = childMeunItemArr
            console.debug('getLoadMeunItem length:', childMeunItemArr)
          }
          return {
            [this.options.value]: child[this.options.value],
            [this.options.label]: child[this.options.label],
            [this.options.children]: child[this.options.children]
              ? child[this.options.children]
              : null,
          }
        })
        meunItemArr.unshift(curMeunItemArr)
        console.debug('getLoadMeunItem:', meunItemArr)
        return meunItemArr
      } else {
        return []
      }
    },
    setActValueArr(arr) {
      this.actValueArr = arr
    },
    meunRowHighlight(index, item) {
      // 菜单 高亮
      // console.debug('meunRowHighlight:', this.actValueArr, index, item)
      if (
        (this.actValueArr.length > 0 &&
          this.actValueArr[index] &&
          this.actValueArr[index] === item[this.options.value]) ||
        (this.actValueArr.length === 0 &&
          this.valueArr[index] &&
          this.valueArr[index] === item[this.options.value])
      ) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cascaderSelectPop {
  position: relative;
  width: 100%;
  height: 56vh;
  background-color: var(--mixtmt_whiteColor);
  padding-top: 2.43vw;
  transition: padding 0.3s linear;
  .cascaderSelectPop_fixed {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    width: 100%;
    padding-bottom: 0.347vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    &.openSearch {
      .searchArea {
        /* background: -moz-linear-gradient(-45deg, #4eaf55 0%, #3d887f 100%); */
        background: -moz-linear-gradient(
          -45deg,
          var(--mixtmt_theme_cascaderSelectPop_1_1) 0%,
          var(--mixtmt_theme_cascaderSelectPop_1_2) 100%
        );
        background: -webkit-gradient(
          left top,
          right bottom,
          color-stop(0%, var(--mixtmt_theme_cascaderSelectPop_1_1)),
          color-stop(100%, var(--mixtmt_theme_cascaderSelectPop_1_2))
        );
        background: -webkit-linear-gradient(
          -45deg,
          var(--mixtmt_theme_cascaderSelectPop_1_1) 0%,
          var(--mixtmt_theme_cascaderSelectPop_1_2) 100%
        );
        background: -o-linear-gradient(
          -45deg,
          var(--mixtmt_theme_cascaderSelectPop_1_1) 0%,
          var(--mixtmt_theme_cascaderSelectPop_1_2) 100%
        );
        background: -ms-linear-gradient(
          -45deg,
          var(--mixtmt_theme_cascaderSelectPop_1_1) 0%,
          var(--mixtmt_theme_cascaderSelectPop_1_2) 100%
        );
        background: linear-gradient(
          135deg,
          var(--mixtmt_theme_cascaderSelectPop_1_1) 0%,
          var(--mixtmt_theme_cascaderSelectPop_1_2) 100%
        );
        /* background: linear-gradient(125deg, var(--mixtmt_theme_cascaderSelectPop_1_1) 0%, var(--mixtmt_theme_cascaderSelectPop_1_2) 100%); */
      }
      .searchArea_btnArea {
        .btnArea_centerWihte {
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    .searchArea {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 0.694vw;
      /* background: #49b17f; */
      background-color: var(--mixtmt_theme_cascaderSelectPop);
      transition: all 0.3s linear;
      .searchList {
        color: var(--mixtmt_whiteColor);
      }
    }
    .searchArea_btnArea {
      position: relative;
      width: 12vw;
      height: 1.388vw;
      border-radius: 0 0 0.347vw 0.347vw;
      /* background-color: #49b17f; */
      background-color: var(--mixtmt_theme_cascaderSelectPop);
      .btnArea_centerWihte {
        position: absolute;
        top: 30%;
        left: 50%;
        z-index: 2;
        width: 26%;
        height: 0.208vw;
        transform: translateX(-50%);
        border-radius: 0.347vw;
        background-color: var(--mixtmt_whiteColor);
        transition: top 0.3s linear;
      }
    }
  }
  .cascaderSelectPop_main {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .selectItem {
      min-width: 9.72vw;
      height: 100%;
      border-right: 1px solid var(--mixtmt_greyColor7);
      position: relative;
      &.isHide,
      &:last-child {
        border-right: 0;
      }
      &.isHide {
        display: none;
      }
      &:last-child {
        /* max-width: 55%; */
        flex: 1;
        .selectItem_list {
          .selectItemList_row {
            padding: 0 1.388vw;

            &.act {
              .selectAct_icon {
                position: absolute;
                left: 0;
                top: 50%;
                z-index: 2;
                font-weight: bold;
                width: 2.778vw;
                height: 2.788vw;
                line-height: 2.788vw;
                text-align: center;
                transform: translateY(-50%);
              }
            }
          }
          .selectRow_name {
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
      .selectItem_status {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        .notData,
        .loadText {
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor6);
        }
        .loaderArea {
          width: 100%;
          height: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .loadText {
            padding-top: 3vw;
          }
        }
      }
      .selectItem_list {
        width: 100%;
        height: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        overflow: auto;
        .selectItemList_row {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          padding: 0 2.778vw 0 1.388vw;
          font-size: 0.972vw;
          height: 2.788vw;
          color: var(--mixtmt_greyColor13);
          .selectRow_icon {
            position: absolute;
            right: 0;
            top: 50%;
            z-index: 2;
            width: 2.778vw;
            height: 2.788vw;
            line-height: 2.788vw;
            text-align: center;
            transform: translateY(-50%);
          }
          .selectRow_name {
            padding: 0 1.388vw;
            line-height: 2.788vw;
          }
          &.act {
            color: var(--mixtmt_mainColor);
            font-weight: bold;
          }
        }
      }
    }
  }

  .loader-67 {
    width: 4.25vw;
    height: 0.54vw;
    display: block;
    position: relative;
    border-radius: 0.347vw;
    color: var(--mixtmt_greyColor8);
    background: currentColor;
    -webkit-animation: animloader66 0.3s 0.3s linear infinite alternate;
    animation: animloader66 0.3s 0.3s linear infinite alternate;
  }
  .loader-67::after,
  .loader-67::before {
    content: '';
    width: 4.25vw;
    height: 0.54vw;
    border-radius: 0.347vw;
    background: currentColor;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 1.5vw;
    -webkit-animation: animloader66 0.3s 0.45s linear infinite alternate;
    animation: animloader66 0.3s 0.45s linear infinite alternate;
  }
  .loader-67::after {
    top: -1.5vw;
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
  }
  @keyframes animloader66 {
    0% {
      width: 0.54vw;
    }
    100% {
      width: 4.25vw;
    }
  }
}

.mixtmt_pc {
  .cascaderSelectPop {
    .cascaderSelectPop_fixed {
      .searchArea_btnArea {
        &:hover {
          cursor: pointer;
        }
      }
    }
    .selectItem_list {
      .selectItemList_row {
        &:hover {
          cursor: pointer;
          background-color: var(--mixtmt_greyColor8);
        }
      }
    }
  }
}
</style>
